import { render, staticRenderFns } from "./newApplicationDebug.vue?vue&type=template&id=89012b10&scoped=true"
import script from "./newApplicationDebug.vue?vue&type=script&lang=js"
export * from "./newApplicationDebug.vue?vue&type=script&lang=js"
import style0 from "./newApplicationDebug.vue?vue&type=style&index=0&id=89012b10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89012b10",
  null
  
)

export default component.exports